import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import NuovoMessaggioFormModel from "./models/NuovoMessaggioFormModel";

type ActionUnion = undefined | HttpErrorResponseModel | NuovoMessaggioFormModel;

export default class MessaggioAction {
    public static readonly REQUEST_SIMULAZIONE_NUOVO_MESSAGGIO_FORM_SET: string =
        "AgendaAction.REQUEST_SIMULAZIONE_NUOVO_MESSAGGIO_FORM_SET";
    public static readonly REQUEST_SIMULAZIONE_NUOVO_MESSAGGIO_FORM_SET_FINISHED: string =
        "AgendaAction.REQUEST_SIMULAZIONE_NUOVO_MESSAGGIO_FORM_SET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_RESET_NUOVO_MESSAGGIO: string =
        "AgendaAction.REQUEST_SIMULAZIONE_RESET_NUOVO_MESSAGGIO";

    public static readonly REQUEST_SIMULAZIONE_SET_INVIA_A_BANCA: string =
        "AgendaAction.REQUEST_SIMULAZIONE_SET_INVIA_A_BANCA";

    public static setNuovoMessaggioForm(form: NuovoMessaggioFormModel): any {
        return ActionUtility.createAction(MessaggioAction.REQUEST_SIMULAZIONE_NUOVO_MESSAGGIO_FORM_SET_FINISHED, form);
    }

    public static setInviaABanca(invia: boolean): any {
        return ActionUtility.createAction(MessaggioAction.REQUEST_SIMULAZIONE_SET_INVIA_A_BANCA, invia);
    }

    public static resetNuovoMessaggio(): any {
        return ActionUtility.createAction(MessaggioAction.REQUEST_SIMULAZIONE_RESET_NUOVO_MESSAGGIO);
    }
}
